/**
 * Renders as a notice box with an icon and a configuratble message.
 * Usage: <UpcomingEvents icon="fa-info-circle" color="var(--uog-red)" grow='2'>Hello this is a notice.</UpcomingEvents>
 */

import React from 'react';
import moment from 'moment';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import RichResult from 'src/uglib_components/richResult';
import * as styles from 'src/uglib_styles/upcomingEvents.module.css'

function UpcomingEvents (props) {

    const [apiResponse, setApiResponse] = useState([]);

    useEffect(() => {
        function fetch_events(category, limit) {

            const eventUrl = 'https://api2-ca.libcal.com/1.0/events?iid=3228&key=56ef23e221edf30a3d37dc6e08e46b56&cal_id=2503&days=90';
            
            let url = eventUrl;
            if(category !== "") {
                url = `${url}&category=${category}`;
            }
        
            if(limit !== 0) {
                url = `${url}&limit=${limit}`;
            }
        
            let events = fetch(url)
                .then(response => response.json())
                .then((body) => body.events )
                .then((events) => {
                    update_events(events);
                });

            return events;
        
        }

        function update_events(events) {

            let event_list = [];
            event_list = events.map((event) => {
                
                const rich_results_event = {
                    "@context": "https://schema.org",
                    "@type": "Event",
                    "name": event.title,
                    "location": "University of Guelph McLaughlin Library",
                    "startDate": event.start,
                    "endDate": event.end,
                    "description": event.description,
                    "organizer": {
                        "@type": "Organization",
                        "@id": "https://www.lib.uoguelph.ca"
                    },
                    "url": event.url.public
                }
                
                return (
                    <React.Fragment key={event.id}>
                        <RichResult data={rich_results_event} />
                        <li className={styles.event}>
                            <div className={styles.date}>
                                <span className={styles.month}>{moment(event.start).format('MMM')}</span>
                                <span>{moment(event.start).format('D')}</span>
                            </div>
                            <div>
                                <a href={event.url.public}>{event.title}</a>
                            </div>
                        </li>
                    </React.Fragment>
                );
            })
            
            setApiResponse(event_list)
        }

        fetch_events(props.category, props.limit);
    }, [props.category, props.limit])


    let more_button_classes = ["btn", "btn-outline-info", styles.more_link].join(' ');

    const empty = apiResponse.length === 0;
    const empty_text = <li>There are no upcoming workshops at the moment. Check back soon for more, or browse our <a href="https://cal.lib.uoguelph.ca/calendar/library_events/?cid=2503&t=g&d=0000-00-00&cal=2503&inc=0">full workshop calendar</a> to see the other workshops we offer.</li>;

    return (<>
        <h2>{props.title}</h2>

        { props.children }
        <ul className={styles.event_list}>
            { apiResponse }
            { empty && empty_text }
        </ul>

        {/* Print empty text when the response is empty */}
        
        <div className={styles.more_links}>
            <a className={more_button_classes} href="/find/workshops">Workshop descriptions</a>
            <a className={more_button_classes} href="https://cal.lib.uoguelph.ca/calendar/library_events/?t=g">Calendar</a>
        </div>
    </>)
    
}

UpcomingEvents.propTypes = {
    category: PropTypes.string,
    limit: PropTypes.number,
    title: PropTypes.string,
}

UpcomingEvents.defaultProps = {
    category: "",
    limit: 5,
    title: "Workshops",
}

export default UpcomingEvents